/**
 * Update Product Use Case
 *
 * Business logic for updating an existing product following clean architecture principles.
 * Handles form data validation, transformation, and product update.
 *
 * @module UpdateProductUseCase
 */

import {ProductRepository} from '../repository/ProductRepository';
import {Product} from '../models/product.model';

export class UpdateProductUseCase {
  constructor (private productRepository: ProductRepository) {}

  /**
   * Execute product update
   * @param id - Product ID to update
   * @param formData - FormData for API submission
   * @returns Promise<Product> - Updated product
   */
  async execute (id: number, formData: FormData): Promise<Product> {
    // Update product through repository
    const product = await this.productRepository.updateProduct(id, formData);

    return product;
  }

}
